export default function ({ glideBehaviour, viewportSize, perView, startAt }) {
    let glideConfig = {
        type: glideBehaviour,
        startAt: startAt ?? 0,
        perView: perView ?? 3,
        gap: 32,
        peek: {
            after: 275,
            before: 0
        }
    }

    if (glideBehaviour === 'slider') {
        glideConfig.rewind = false
        glideConfig.bound = true
    }

    if (viewportSize < 720) {
        return Object.assign(glideConfig, {
            perView: 1,
            gap: 25,
            peek: {
                after: 75,
                before: 0
            }
        })
    } else if (viewportSize < 1000) {
        return Object.assign(glideConfig, {
            perView: 2,
            gap: 25,
            peek: {
                after: 75,
                before: 0
            }
        })
    } else if (viewportSize < 1200) {
        return Object.assign(glideConfig, {
            perView: 3,
            gap: 25,
            peek: {
                after: 75,
                before: 0
            }
        })
    } else {
        return glideConfig
    }
}
